import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RootContainer from './RootContainer';

ReactDOM.render(
  <React.StrictMode>
    <RootContainer />
  </React.StrictMode>,
  document.getElementById('gridwrapper')
);
